import { combineReducers } from 'redux'

import componentsReducer from './Component/componentReducer'
import csvUploadReducer from './CsvUpload/csvUploadReducer'
import dataLoadReducer from './DataLoad/dlReducer'
import dateFormReducer from './DateForm/formReducer'
import dialogflowReducer from './DialogFlow/dialogFlowReducer'
import downloadTemplateReducer from './DownloadTemplate/downloadTemplateReducer'
import dynamicFormsReducer from './DynamicForms/dynamicFormsReducer'
import fileDataReducer from './FileData/fileDataReducer'
import formInputsReducer from './FormInputs/formInputReducer'
import getTemplateReducer from './GetTemplate/getTemplateReducer'
import interactions from './Interactions/interactionsReducer'
import loginReducer from './Login/loginReducer'
import popupReducer from './Popup/popupReducer'
import processArrayReducer from './ProcessArray/processArrayReducer'
import processDefnReducer from './ProcessDefn/processDefnReducer'
import selectAppReducer from './SelectApp/saReducer'
import selectProcessReducer from './SelectProcess/spReducer'
import subTreeReducer from './SubTree/subTreeReducer'
import treeReducer from './Tree/treeReducer'
import VR2Reducer from './VR2/vr2Reducer'
import commonReducer from './Common/commonReducer'
import layoutReducer from './SideBarDrawer/SideBarDrawerReducer'
import dashboardReducer from './Dashboard/dashboardReducer'

export default combineReducers({
  layout: layoutReducer,
  tree: treeReducer,
  subTree: subTreeReducer,
  VR2: VR2Reducer,
  dynamicForms: dynamicFormsReducer,
  popup: popupReducer,
  login: loginReducer,
  common: commonReducer,
  interactions,
  components: componentsReducer,
  selectApp: selectAppReducer,
  selectProcess: selectProcessReducer,
  fileData: fileDataReducer,
  dateForm: dateFormReducer,
  dataLoad: dataLoadReducer,
  dialogflow: dialogflowReducer,
  processArray: processArrayReducer,
  processDefn: processDefnReducer,
  getTemplate: getTemplateReducer,
  downloadTemplate: downloadTemplateReducer,
  csvUpload: csvUploadReducer,
  chatbotFormInputs: formInputsReducer,
  dashboard: dashboardReducer
})
